import getBasePath from './getBasePath'

function formatSlug(slug: string, locale: string): string {
  const basePath = trimSlashes(getBasePath(locale))
  const cleanSlug = slug ? trimSlashes(slug) : ''

  const localePrefix = locale.indexOf('en') === 0 ? '' : locale

  const formattedSlug = `${[localePrefix, basePath, cleanSlug].filter(s => s.length > 0).join('/')}`

  return formattedSlug === '' ? '/' : `/${formattedSlug}/`
}

function trimSlashes(url: string): string {
  return url.replace(/^\/|\/$/g, '')
}

export {trimSlashes}
export default formatSlug
